//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from "@angular/core";

//local imports
import { PresenterRegistration } from "@app/shared";
import { AbstractRoomContentModel } from "@app/catalog-common";
import { RoomContentDisplayMode } from "../room-content-item";


@PresenterRegistration({
   types: [AbstractRoomContentModel],
   key:"breadcrumb-item",
})
@Component({
    selector: 'room-content-breadcrumb-presenter',
    template: '<room-content-item [id]="data().id" [roomContent]="data()" [displayMode]="DisplayMode.Code" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoomContentBreadcrumbPresenterComponent {

    DisplayMode: typeof RoomContentDisplayMode = RoomContentDisplayMode;
    
    public data: WritableSignal<AbstractRoomContentModel>;
    
    constructor() {
        this.data = signal<AbstractRoomContentModel>(null);
    }
}